import { RouteObject } from "react-router-dom";

import ProtectedRoute from "../Routes/ProtectedRoute";
import { PredefinedWord } from "../Routes/Predefined";
import { ROUTES } from "../Routes/routes";

import CentralDesignerHubLayout from "../layouts/CentralDesignerHubLayout";
import DashboardDesignerCentralHub from "../components/CentralHub/Designer/Dashboard";
import DesignerProfile from "../components/CentralHub/Designer/DesignerProfile";
import DesignerReport from "../components/CentralHub/Designer/DesignerReport";
import ChangePassword from "../layouts/ChangePassword";
import DesignerSchedule from "../components/CentralHub/Designer/DesignerSchedule";
import DesignerCompleteOrders from "../components/CentralHub/Designer/DesignerCompleteOrders";

export const designerRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute
        allowedRoles={[PredefinedWord.Roles.CENTRAL.DESIGNER]}
      />
    ),
    children: [
      {
        element: <CentralDesignerHubLayout />,
        children: [
          {
            path: ROUTES.CENTRAL.Designer.DESIGNER_DASHBOARD,
            element: <DashboardDesignerCentralHub />,
          },
          {
            path: ROUTES.CENTRAL.Designer.DESIGNER_PROFILE,
            element: <DesignerProfile />,
          },
          {
            path: ROUTES.CENTRAL.Designer.ChangePassword,
            element: <ChangePassword />,
          },
          {
            path: ROUTES.CENTRAL.Designer.DesignerReport,
            element: <DesignerReport />,
          },
          {
            path: ROUTES.CENTRAL.Designer.Settings.officetimings,
            element: <DesignerSchedule />,
          },
          {
            path: ROUTES.CENTRAL.Designer.DesignerCompleteOrders,
            element: <DesignerCompleteOrders />,
          },
        ],
      },
    ],
  },
];